// extracted by mini-css-extract-plugin
export default {"wrapper":"EditInventory_wrapper__BaM7B"};